__turbopack_context__.v({
  "className": "lq6jaa_className",
  "variable": "lq6jaa_variable",
});
